<template>
  <div class="process-flow">
    <page-header title="系统流程" icon="el-icon-share" />
    <!-- 修改对话框标题 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="20%">
      <el-form :model="processForm" label-width="80px">
        <el-form-item label="流程类型">
          <el-select
            v-model="processForm.type"
            placeholder="请选择流程类型"
            filterable
            remote
            :remote-method="remoteSearch"
            :loading="loading"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.itemId"
              :label="item.itemLabel"
              :value="item.itemId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="流程名称">
          <el-input v-model="processForm.name" placeholder="请输入流程名称"></el-input>
        </el-form-item>
        <el-form-item label="流程状态">
          <el-select v-model="processForm.status" placeholder="请选择流程状态">
            <el-option label="启用" value="active"></el-option>
            <el-option label="禁用" value="inactive"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="流程描述">
          <el-input v-model="processForm.description" placeholder="请输入流程描述"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="processForm.remark" placeholder="请输入备注" :rows="3"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 搜索栏 -->
    <el-card class="search-card">
      <div class="card-title">
        <i class="el-icon-search"></i>
        <span>筛选查询</span>
      </div>
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="流程类型">
          <el-select v-model="searchForm.type" placeholder="请输入流程类型" class="filter-item">
            <el-option label="全部" value="all"></el-option>
            <el-option label="报单处理" value="report"></el-option>
            <el-option label="审批流程" value="approve"></el-option>
            <el-option label="退货流程" value="return"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="流程名称">
          <el-input v-model="searchForm.name" placeholder="请输入流程名称" class="filter-item"></el-input>
        </el-form-item>
        <el-form-item label="流程状态">
          <el-select v-model="searchForm.status" placeholder="请输入流程状态" class="filter-item">
            <el-option label="启用" value="active"></el-option>
            <el-option label="禁用" value="inactive"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="filter-buttons">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 数据列表 -->
    <el-card class="table-card">
      <div class="card-title">
        <i class="el-icon-tickets"></i>
        <span>数据列表</span>
      </div>

      <!-- 操作按钮 -->
      <div class="operation-bar">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增流程</el-button>
        <!-- <el-button type="danger" icon="el-icon-delete" @click="handleBatchDelete">批量删除</el-button> -->
      </div>

      <!-- 流程列表 -->
      <el-table 
        v-loading="tableLoading"
        element-loading-text="加载中..."
        :data="tableData" 
        style="width: 100%" 
        border 
        stripe 
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="ProcessKindName" label="流程类型" width="180" align="center">
          <!-- <template slot-scope="scope">
            <el-tag size="medium">
              {{ getProcessTypeName(scope.row.ProcessKindName) }}
            </el-tag>
          </template> -->
        </el-table-column>
        <el-table-column prop="name" label="流程名称" align="center"></el-table-column>
        <el-table-column prop="description" label="流程描述" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180" align="center">
          <template slot-scope="scope">
            {{ scope.row.createTime ? new Date(scope.row.createTime).toLocaleString() : '' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.row)">修改</el-button>
            <el-button size="mini" type="success" icon="el-icon-share" @click="handleConfig(scope.row)">流程节点</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import request from '@/utils/request'
import PageHeader from '@/components/common/PageHeader'

export default {
  name: 'ProcessFlow',
  components: {
    PageHeader
  },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '新增流程', // 对话框标题
      isEdit: false, // 是否是编辑模式
      processForm: {
        id: '', // 新增时为空，修改时有值
        type: '',
        name: '',
        status: '',
        description: '',
        remark: ''
      },
      searchForm: {
        type: '',
        name: '',
        status: ''
      },
      tableData: [
       
      ],
      multipleSelection: [],
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 100,
      // 添加新的数据属性
      typeOptions: [], // 流程类型选项
      loading: false, // 加载状态
      tableLoading: true, // 表格加载状态
    }
  },
  methods: {
    // 打开新增对话框
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增流程'
      this.processForm = {
        id: '',
        type: '',
        name: '',
        status: '',
        description: '',
        remark: ''
      }
      this.dialogVisible = true
    },

    // 打开修改对话框
    handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '修改流程'
      this.processForm = {
        id: row.id,
        type: row.type,
        name: row.name,
        status: row.status === 1 ? 'active' : 'inactive',
        description: row.description,
        remark: row.remark,
        processKind: row.processKind

      }
      this.dialogVisible = true
    },

    // 统一的提交处理
    async handleSubmit() {
      try {
        // 表单验证
        if (!this.processForm.type) {
          this.$message.warning('请选择流程类型')
          return
        }
        if (!this.processForm.name) {
          this.$message.warning('请输入流程名称')
          return
        }
        if (!this.processForm.status) {
          this.$message.warning('请选择流程状态')
          return
        }

        // 构建请求参数
        const params = {
          processId: this.processForm.id, // 新增时为空，修改时有值
          processName: this.processForm.name,
          processKind: this.processForm.type,
          status: this.processForm.status === 'active' ? 1 : 0,
          description: this.processForm.description,
          remark: this.processForm.remark
        }

        const res = await request({
          url: '/api/v1/process/save',
          method: 'POST',
          data: params
        })

        if (res.status === 1) {
          this.$message.success(this.isEdit ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.fetchProcessList()
        } else {
          this.$message.error(res.msg || (this.isEdit ? '修改失败' : '新增失败'))
        }
      } catch (error) {
        console.error('保存流程错误:', error)
        this.$message.error(this.isEdit ? '修改失败' : '新增失败')
      }
    },
    async fetchProcessList() {
      // 清空数据并显示加载状态
      this.tableData = []
      this.tableLoading = true
      this.total = 0
      
      try {
        const res = await request({
          url: '/api/v1/process/list',
          method: 'POST',
          data: {
            page: this.currentPage,
            size: this.pageSize,
            name: this.searchForm.name || '',
            status: -1
          }
        })

        if (res.status === 1) {
          console.log('流程列表数据:', res.data)
          this.tableData = res.data.list.map(item => ({
            id: item.processId,
            type: item.processKind,
            name: item.processName,
            createTime: item.createdAt,
            description: item.description,
            remark: item.remark,
            status: item.status,
            ProcessKindName: item.processKindName
          }))
          this.total = res.data.total
        } else {
          this.$message.error(res.msg || '获取流程列表失败')
        }
      } catch (error) {
        console.error('获取流程列表错误:', error)
        this.$message.error('获取流程列表失败')
      } finally {
        // 无论成功失败都关闭加载状态
        this.tableLoading = false
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.fetchProcessList()
    },
    handleReset() {
      this.searchForm = {
        type: '',
        name: '',
        status: ''
      }
      this.currentPage = 1
      this.fetchProcessList()
    },
    async handleBatchDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择要删除的流程')
        return
      }

      try {
        await this.$confirm('确认删除选中的流程?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        // 获取选中的流程ID
        const processId = this.multipleSelection[0].id

        const res = await request({
          url: '/api/v1/process/delete',
          method: 'POST',
          data: {
            processId: processId
          }
        })

        if (res.status === 1) {
          this.$message.success('删除成功')
          // 刷新列表
          this.fetchProcessList()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除流程错误:', error)
          this.$message.error('删除失败')
        }
      }
    },
    handleConfig(row) {
      // 跳转到流程节点配置页面
      this.$router.push(`/process/ProcessNode/${row.id}`)
     // this.$router.push(`/process/node/${row.id}`)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchProcessList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchProcessList()
    },
    async handleDelete(row) {
      try {
        // 显示确认对话框
        await this.$confirm('确认删除该流程?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        // 调用删除接口
        const res = await request({
          url: '/api/v1/process/delete',
          method: 'POST',
          data: {
            processId: row.id  // 传入要删除的流程ID
          }
        })

        // 处理响应结果
        if (res.status === 1) {
          this.$message.success('删除成功')
          // 刷新列表
          this.fetchProcessList()
        } else {
          this.$message.error(res.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') { // 排除用户取消的情况
          console.error('删除流程错误:', error)
          this.$message.error('删除失败')
        }
      }
    },
    getProcessTypeName(type) {
      const typeMap = {
        'all': '全部',
        'report': '报单流程',
        'deposit': '押金退还流程',
        'purchase': '采购审批流程',
        'other': '其他流程'
      }
      return typeMap[type] || type
    },
    // 远程搜索方法
    async remoteSearch(query) {
      if (query !== '') {
        this.loading = true
        try {
          const res = await request({
            url: '/api/v1/dict/type',
            method: 'post',
            data: {
              dictType: 'xtlc',
              dictItemName: ''
            }
          })
          
          if (res.status === 1 && res.data) {
            this.typeOptions = res.data.map(item => ({
              itemId: item.itemId,
              itemLabel: item.itemLabel,
              itemValue: item.itemValue
            }))
          } else {
            this.$message.error(res.msg || '获取流程类型失败')
          }
        } catch (error) {
          console.error('获取流程类型错误:', error)
          this.$message.error('获取流程类型失败')
        } finally {
          this.loading = false
        }
      }
    },

    // 初始化获取流程类型
    async initProcessTypes() {
      try {
        const res = await request({
          url: '/api/v1/dict/type',
          method: 'post',
          data: {
            dictType: 'xtlc',
            dictItemName: ''  // 空字符串获取所有选项
          }
        })
        
        if (res.status === 1 && res.data) {
          this.typeOptions = res.data.map(item => ({
            itemId: item.itemId,
            itemLabel: item.itemLabel,
            itemValue: item.itemId
          }))
        } else {
          this.$message.error(res.msg || '获取流程类型失败')
        }
      } catch (error) {
        console.error('获取流程类型错误:', error)
        this.$message.error('获取流程类型失败')
      }
    }
  },
  created() {
    // 在组件创建时获取初始流程类型列表
    this.initProcessTypes()
    this.fetchProcessList()
  }
}
</script>

<style lang="scss" scoped>
.process-flow {
  padding: 20px;
  background-color: #f0f2f5;
  min-height: calc(100vh - 84px);

  .search-card,
  .table-card {
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    padding: 0;
  }

  .card-title {
    border-bottom: 1px solid #ebeef5;
    padding: 15px 20px;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
  }

  .card-title i {
    margin-right: 8px;
    color: #409EFF;
  }

  .filter-item {
    width: 200px;
  }

  .filter-buttons {
    margin-left: 10px;
  }

  .operation-bar {
    margin: 20px;
  }

  .el-table {
    margin: 0;
  }

  :deep(.el-table td) {
    padding: 12px 0;
  }

  :deep(.el-table th) {
    padding: 12px 0;
    background-color: #f5f7fa;
  }

  .pagination-container {
    padding: 20px;
    text-align: right;
    background: #fff;
  }

  .el-button.el-button--mini {
    padding: 7px 12px;
  }

  .el-button.el-button--mini+.el-button.el-button--mini {
    margin-left: 12px;
  }

  .el-tag {
    margin: 0;
    padding: 0 12px;
    height: 28px;
    line-height: 26px;
  }

  :deep(.el-dialog) {
    min-width: 400px;
  }

  :deep(.el-select) {
    width: 100%;
  }

  :deep(.el-form-item) {
    margin-bottom: 20px;
  }

  :deep(.el-input),
  :deep(.el-textarea) {
    width: 100%;
  }
}
</style>